export default __webpack_public_path__ + "static/media/Ies_panel_JesusEspinoza.48d973c5.png";